import "../../../components/welcomeScreen/welcomeWizard.scss";

import { List } from "immutable";
import { isArray } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalBody from "../../../components/modal/ModalBody";
import ModalHeading from "../../../components/modal/ModalHeading";
import ModalView from "../../../components/modal/ModalView";
import PageSlider from "../../../components/pageSlider";
import WelcomeWizardFooter from "../../../components/welcomeScreen/WelcomeWizardFooter";
import PubSubTopics from "../../../constants/pubSubTopics";
import sliderTransitions from "../../../constants/sliderTransitions";
import upgradeV2DataWithV3Template from "../../../dataConversion/v2Upgrade/upgradeV2DataWithV3Template";
import batchOperations from "../../../modules/batchOperations";
import chainReducer, { batchActions } from "../../../modules/chainReducer";
import definitionReducer, { definitionActionTypes, definitionSelectors } from "../../../modules/definition";
import rootOperations from "../../../modules/rootOperations";
import { uiStateSelectors } from "../../../modules/uiState";
import { undoRedoOperations } from "../../../modules/undoRedo";
import { welcomeSelectors } from "../../../modules/welcome";
import { nativeCommsBroadcastMessageTypes } from "../../../nativeComms";
import { loadSuggestionGroup } from "../../../suggestionLibrary";
import templates from "../../../templates";
import { createFromJS } from "../../../types";
import { trackEvent } from "../../../utils/trackAnalytics";
import settingsSelectors from "../../settingsModal/selectors";
import CustomizeDataPage from "./CustomizeDataPage";
import DefaultsPage from "./DefaultsPage";
import DependenciesPage from "./DependenciesPage";
import EnableSyncPage from "./EnableSyncPage";
import FinalPage from "./FinalPage";
import NarrativePage from "./NarrativePage";
import SelectGroupPage from "./SelectGroupPage";
import selectors from "./selectors";
import SelectTemplatePage from "./SelectTemplatePage";

const GROUP_PAGE = "GROUP_PAGE";
const TEMPLATE_PAGE = "TEMPLATE_PAGE";
const NARRATIVE_PAGE = "NARRATIVE_PAGE";
const DEFAULTS_PAGE = "DEFAULTS_PAGE";
const CUSTOMIZE_DATA_PAGE = "CUSTOMIZE_DATA_PAGE";
const DEPENDENCIES_PAGE = "DEPENDENCIES_PAGE";
const ENABLE_SYNCING_PAGE = "ENABLE_SYNCING_PAGE";
// const CHOOSE_SYNC_PROJECT_PAGE = "CHOOSE_SYNC_PROJECT_PAGE";
// const CONFIGURE_SYNC_FOLDERS_PAGE = "CONFIGURE_SYNC_FOLDERS_PAGE";
// const REMOVE_OLD_SYNC_FIELDS_PAGE = "REMOVE_OLD_SYNC_FIELDS_PAGE";
const DONE_PAGE = "DONE_PAGE";

const renderGroupPage = onGroupClick => <SelectGroupPage onGroupClick={onGroupClick} />;

const renderTemplatePage = (groupId, onTemplateClick, onBackClick) => (
  <SelectTemplatePage groupId={groupId} onTemplateClick={onTemplateClick} onBackClick={onBackClick} />
);
const renderTemplateFooter = onBackClick => {
  let footer = null;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter key="footer" showBack={true} onBackClick={onBackClick} showDone={false} showNext={false} />
  );
  //#!endif
  return footer;
};

const renderNarrativePage = (
  isNarrativeAllowed,
  includeNarrative,
  dispatchLocal,
  onNextClick,
  onBackClick,
  availableSyncProjects,
  defaultNarrativeType,
  defaultSequenceType
) => (
  <NarrativePage
    isNarrativeAllowed={isNarrativeAllowed}
    includeNarrative={includeNarrative}
    dispatchLocal={dispatchLocal}
    onNextClick={onNextClick}
    onBackClick={onBackClick}
    availableSyncProjects={availableSyncProjects}
    defaultNarrativeType={defaultNarrativeType}
    defaultSequenceType={defaultSequenceType}
  />
);
const renderNarrativeFooter = (onNextClick, onBackClick) => {
  let footer = null;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={false}
      showNext={true}
      onNextClick={onNextClick}
    />
  );
  //#!endif
  return footer;
};

const renderDefaultsPage = (
  types,
  properties,
  references,
  templateName,
  dispatchLocal,
  onNextClick,
  onBackClick,
  includeDataTypes,
  defaultSequenceType,
  onCustomizeClick,
  onIncludeDataTypesChange
) => (
  <DefaultsPage
    types={types}
    properties={properties}
    references={references}
    templateName={templateName}
    dispatchLocal={dispatchLocal}
    onNextClick={onNextClick}
    onBackClick={onBackClick}
    includeDataTypes={includeDataTypes}
    defaultSequenceType={defaultSequenceType}
    onCustomizeClick={onCustomizeClick}
    onIncludeDataTypesChange={onIncludeDataTypesChange}
  />
);
const renderDefaultsFooter = (types, references, onNextClick, onBackClick, defaultSequenceType, onCustomizeClick) => {
  let footer = null;
  const enabledEventTypes = settingsSelectors.eventTypesFromAllTypes(types).filter(t => t.enabled);
  const isValid = enabledEventTypes.size > 0;
  const eventTypes = settingsSelectors.eventTypesFromAllTypes(types);
  const personTypes = settingsSelectors.personTypesFromAllTypes(types);
  const filteredEventTypes = eventTypes.filter(type => type.id != defaultSequenceType);
  const eventToPersonReferences = settingsSelectors.eventToPersonReferences(references, eventTypes, personTypes);
  const eventToEventReferences = settingsSelectors
    .eventToEventReferences(references, eventTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));
  const personToPersonReferences = settingsSelectors
    .personToPersonReferences(references, personTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={true}
      onDoneClick={onNextClick}
      doneText="Next"
      disableDone={!isValid}
      showNext={Boolean(filteredEventTypes.size || eventToEventReferences.size || personToPersonReferences.size)}
      onNextClick={onCustomizeClick}
      nextText="Customize"
    />
  );
  //#!endif
  return footer;
};

const renderCustomizeDataPage = (
  types,
  properties,
  references,
  dispatchLocal,
  onNextClick,
  onBackClick,
  includeDataTypes,
  defaultSequenceType,
  onCustomizeClick
) => (
  <CustomizeDataPage
    types={types}
    properties={properties}
    references={references}
    dispatchLocal={dispatchLocal}
    onNextClick={onNextClick}
    onBackClick={onBackClick}
    includeDataTypes={includeDataTypes}
    defaultSequenceType={defaultSequenceType}
    onCustomizeClick={onCustomizeClick}
  />
);
const renderCustomizeDataFooter = (types, onNextClick, onBackClick) => {
  let footer = null;
  const enabledEventTypes = settingsSelectors.eventTypesFromAllTypes(types).filter(t => t.enabled);
  const isValid = enabledEventTypes.size > 0;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={true}
      onDoneClick={onNextClick}
      doneText="Next"
      disableDone={!isValid}
      showNext={false}
    />
  );
  //#!endif
  return footer;
};

const renderDependenciesPage = (
  createConstraintsFromV2Dependencies,
  onDependenciesChange,
  dispatchLocal,
  onNextClick,
  onBackClick
) => (
  <DependenciesPage
    createConstraintsFromV2Dependencies={createConstraintsFromV2Dependencies}
    onDependenciesChange={onDependenciesChange}
    dispatchLocal={dispatchLocal}
    onNextClick={onNextClick}
    onBackClick={onBackClick}
  />
);
const renderDependenciesFooter = (onNextClick, onBackClick) => {
  let footer = null;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={false}
      showNext={true}
      onNextClick={onNextClick}
    />
  );
  //#!endif
  return footer;
};

const renderEnableSyncPage = (
  availableSyncProjects,
  selectedSyncProject,
  onSyncProjectChange,
  onNextClick,
  onBackClick,
  includeNarrative
) => (
  <EnableSyncPage
    availableProjects={availableSyncProjects}
    selectedProject={selectedSyncProject}
    onProjectChange={onSyncProjectChange}
    onNextClick={onNextClick}
    onBackClick={onBackClick}
    includeNarrative={includeNarrative}
  />
);
const renderEnableSyncFooter = (onNextClick, onBackClick) => {
  let footer = null;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={false}
      showNext={true}
      onNextClick={onNextClick}
    />
  );
  //#!endif
  return footer;
};

const renderFinalPage = (onDoneClick, onBackClick) => <FinalPage onDoneClick={onDoneClick} onBackClick={onBackClick} />;
const renderFinalFooter = (onDoneClick, onBackClick) => {
  let footer = null;
  //#!if iOS !== true
  footer = (
    <WelcomeWizardFooter
      key="footer"
      showBack={true}
      onBackClick={onBackClick}
      showDone={true}
      onDoneClick={onDoneClick}
      doneText="Create"
    />
  );
  //#!endif
  return footer;
};

class UpgradeWizard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      localStore: null,
      defaultLocalStore: null,
      stepHistory: List([GROUP_PAGE]),
      selectedGroup: null,
      selectedTemplate: null,
      createConstraintsFromV2Dependencies: true
    };
    this.dispatchLocal = this.dispatchLocal.bind(this);
    this.showNextStep = this.showNextStep.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onGroupClick = this.onGroupClick.bind(this);
    this.onTemplateClick = this.onTemplateClick.bind(this);
    this.onNarrativeNextClick = this.onNarrativeNextClick.bind(this);
    this.onCustomizeDataNextClick = this.onCustomizeDataNextClick.bind(this);
    this.onEnableSyncNextClick = this.onEnableSyncNextClick.bind(this);
    this.onSyncProjectChange = this.onSyncProjectChange.bind(this);
    this.onUpgradeClick = this.onUpgradeClick.bind(this);
    this.onCustomizeClick = this.onCustomizeClick.bind(this);
    this.onDefaultsNextClick = this.onDefaultsNextClick.bind(this);
    this.onDependenciesNextClick = this.onDependenciesNextClick.bind(this);
    this.onDependenciesChange = this.onDependenciesChange.bind(this);

    this._enabledOtherType = List();
  }

  componentWillMount() {
    this.copyLocalStore(this.props);
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  copyLocalStore(props) {
    this.setState({
      localStore: props.localStore,
      defaultLocalStore: props.localStore,
      selectedSyncProject: props.selectedSyncProject
    });
  }

  dispatchLocal(actions) {
    const performAction = isArray(actions) ? batchActions(actions) : actions;
    const newStore = this.state.localStore.set(
      "definitions",
      chainReducer(definitionReducer)(this.state.localStore.definitions, performAction, this.state.localStore)
    );

    let stateToSave = {
      localStore: newStore
    };

    // Do we also want to preserve the local state?
    if (actions.type === definitionActionTypes.REPLACE_DEFINITIONS) {
      stateToSave.defaultLocalStore = newStore;
    }
    this.setState(stateToSave);
  }

  onBackClick() {
    this.setState({ stepHistory: this.state.stepHistory.pop() });
  }

  showNextStep(stepId) {
    const history = this.state.stepHistory;
    this.setState({
      stepHistory: history.push(stepId)
    });
  }

  onGroupClick(groupId) {
    this.setState({ selectedGroup: groupId });
    this.showNextStep(TEMPLATE_PAGE);

    trackEvent("upgradeWizardGroupClick", "upgradeWizard", groupId);
  }

  onTemplateClick(templateId) {
    const group = templates.find(g => g.id === this.state.selectedGroup);
    const t = group.templates.find(g => g.id === templateId);
    const templateData = t.template;
    const timelineData = templateData.definitions ? templateData : { definitions: templateData };
    const newStore = createFromJS.TimelineRecord(timelineData);
    let stateToSave = {
      selectedTemplate: templateId,
      templateName: t.label,
      isNarrativeEverAllowed: newStore.definitions.includeNarrative,
      localStore: newStore,
      defaultLocalStore: newStore
    };
    this.setState(stateToSave, () => {
      this.showNextStep(NARRATIVE_PAGE);
    });
    trackEvent("upgradeWizardTemplateClick", "upgradeWizard", t.label);
  }

  onNarrativeNextClick() {
    this.showNextStep(DEFAULTS_PAGE);
  }

  onDefaultsNextClick() {
    if (this.props.incomingUpgradeData.dependencies.length) {
      this.showNextStep(DEPENDENCIES_PAGE);
    } else {
      this.showNextStep(ENABLE_SYNCING_PAGE);
    }

    trackEvent("upgradeWizardUseDefaults", "upgradeWizard");
  }

  onCustomizeDataNextClick() {
    if (this.props.incomingUpgradeData.dependencies.length) {
      this.showNextStep(DEPENDENCIES_PAGE);
    } else {
      this.showNextStep(ENABLE_SYNCING_PAGE);
    }

    trackEvent("upgradeWizardCustomize", "upgradeWizard");
  }

  onDependenciesNextClick() {
    this.showNextStep(ENABLE_SYNCING_PAGE);
  }

  onSyncProjectChange(selectedSyncProject) {
    this.setState({
      selectedSyncProject
    });
  }

  onEnableSyncNextClick() {
    this.showNextStep(DONE_PAGE);
  }

  onDependenciesChange(value) {
    this.setState({
      createConstraintsFromV2Dependencies: value
    });
  }

  onUpgradeClick() {
    // Now that we know we are creating something new with this template, we need to work out what onboarding
    // we want to load.
    const upgradedTimelineData = upgradeV2DataWithV3Template(
      this.props.incomingUpgradeData,
      this.state.localStore,
      this.state.selectedSyncProject,
      this.state.createConstraintsFromV2Dependencies,
      this._enabledOtherType.map(t => t.id).toJS()
    );

    // This can vary by template by looking at:
    // this.state.selectedGroup, this.state.selectedTemplate, or this.state.localStore.definitions
    const suggestionGroups = [
      this.state.localStore.definitions.includeNarrative
        ? loadSuggestionGroup("explore")
        : loadSuggestionGroup("exploreNoNarrative")
    ];

    // TODO: Add in other suggestions for upgrading users

    trackEvent("upgradeWizardUpgrade", "upgradeWizard");
    this.props.onUpgradeFile(
      upgradedTimelineData,
      suggestionGroups,
      this.state.selectedGroup,
      this.state.selectedTemplate,
      this.props.fileName
    );
  }

  onCustomizeClick() {
    this.showNextStep(CUSTOMIZE_DATA_PAGE);
  }

  render() {
    const currentStep = this.state.stepHistory.last();
    const types = settingsSelectors.getAllOrderedTypes(this.state.localStore);
    const properties = settingsSelectors.getAllOrderedProperties(this.state.localStore);
    const references = settingsSelectors.getAllOrderedReferences(this.state.localStore);
    const defaultNarrativeType = definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore);
    const defaultSequenceType = definitionSelectors.getDefaultSequenceType(this.state.localStore);
    let content = null;
    let title = "Template Wizard";
    let pageIndex = 0;
    let showCancel = false;
    let showBack = false;

    let showRightButton = false;
    let onRightButtonClick = null;
    let rightButtonLabel = null;
    let footer = null;

    // const GROUP_PAGE = "GROUP_PAGE";
    // const TEMPLATE_PAGE = "TEMPLATE_PAGE";
    // const NARRATIVE_PAGE = "NARRATIVE_PAGE";
    // const CUSTOMIZE_DATA_PAGE = "CUSTOMIZE_DATA_PAGE";
    // const ENABLE_SYNCING_PAGE = "ENABLE_SYNCING_PAGE";
    // const CHOOSE_SYNC_PROJECT_PAGE = "CHOOSE_SYNC_PROJECT_PAGE";
    // const CONFIGURE_SYNC_FOLDERS_PAGE = "CONFIGURE_SYNC_FOLDERS_PAGE";
    // const REMOVE_OLD_SYNC_FIELDS_PAGE = "REMOVE_OLD_SYNC_FIELDS_PAGE";
    // const DONE_PAGE = "DONE_PAGE";

    switch (currentStep) {
      case GROUP_PAGE:
        content = renderGroupPage(this.onGroupClick);
        title = "Update File";
        pageIndex = 1;
        showCancel = true;
        showRightButton = false;
        break;
      case TEMPLATE_PAGE: {
        const group = templates.find(g => g.id === this.state.selectedGroup);
        content = renderTemplatePage(this.state.selectedGroup, this.onTemplateClick, this.onBackClick);
        footer = renderTemplateFooter(this.onBackClick);
        title = group.label;
        pageIndex = 2;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showBack = true;
        break;
      }
      case NARRATIVE_PAGE:
        content = renderNarrativePage(
          this.state.isNarrativeEverAllowed,
          this.state.localStore.definitions.includeNarrative,
          this.dispatchLocal,
          this.onNarrativeNextClick,
          this.onBackClick,
          this.props.availableSyncProjects,
          defaultNarrativeType,
          defaultSequenceType
        );
        footer = renderNarrativeFooter(this.onNarrativeNextClick, this.onBackClick);
        title = `New Narrative`;
        pageIndex = 4;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.onNarrativeNextClick;
        rightButtonLabel = "Next";
        break;
      case DEFAULTS_PAGE:
        content = renderDefaultsPage(
          types,
          properties,
          references,
          this.state.templateName,
          this.dispatchLocal,
          this.onDefaultsNextClick,
          this.onBackClick,
          this.state.localStore.definitions.types.byId.find(type => !type.enabled) ? false : true,
          defaultSequenceType,
          this.onCustomizeClick,
          ids => (this._enabledOtherType = ids)
        );
        footer = renderDefaultsFooter(
          types,
          references,
          this.onDefaultsNextClick,
          this.onBackClick,
          defaultSequenceType,
          this.onCustomizeClick
        );
        title = `New Types`;
        pageIndex = 5;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.state.localStore.definitions.types.byId.filter(item => item.enabled).size
          ? this.onDefaultsNextClick
          : null;
        rightButtonLabel = "Next";
        break;
      case CUSTOMIZE_DATA_PAGE:
        content = renderCustomizeDataPage(
          types,
          properties,
          references,
          this.dispatchLocal,
          this.onCustomizeDataNextClick,
          this.onBackClick,
          this.state.localStore.definitions.types.byId.find(type => !type.enabled) ? false : true,
          defaultSequenceType,
          this.onCustomizeClick
        );
        footer = renderCustomizeDataFooter(types, this.onCustomizeDataNextClick, this.onBackClick);
        title = `Customize`;
        pageIndex = 6;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.state.localStore.definitions.types.byId.filter(item => item.enabled).size
          ? this.onCustomizeDataNextClick
          : null;
        rightButtonLabel = "Next";
        break;
      case DEPENDENCIES_PAGE:
        content = renderDependenciesPage(
          this.state.createConstraintsFromV2Dependencies,
          this.onDependenciesChange,
          this.dispatchLocal,
          this.onDependenciesNextClick,
          this.onBackClick
        );
        footer = renderDependenciesFooter(this.onDependenciesNextClick, this.onBackClick);
        title = `New Dependencies`;
        pageIndex = 7;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.onDependenciesNextClick;
        rightButtonLabel = "Next";
        break;
      case ENABLE_SYNCING_PAGE:
        content = renderEnableSyncPage(
          this.props.availableSyncProjects,
          this.state.selectedSyncProject,
          this.onSyncProjectChange,
          this.onEnableSyncNextClick,
          this.onBackClick,
          this.state.localStore.definitions.includeNarrative
        );
        footer = renderEnableSyncFooter(this.onEnableSyncNextClick, this.onBackClick);
        title = `Improved Syncing`;
        pageIndex = 8;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.onEnableSyncNextClick;
        rightButtonLabel = "Next";
        break;
      case DONE_PAGE:
        content = renderFinalPage(this.onUpgradeClick, this.onBackClick);
        footer = renderFinalFooter(this.onUpgradeClick, this.onBackClick);
        title = `Ready to go`;
        pageIndex = 9;
        showBack = true;
        //#!if iOS !== true
        showCancel = true;
        //#!endif
        showRightButton = true;
        onRightButtonClick = this.onUpgradeClick;
        rightButtonLabel = "Done";
        break;
      default:
        break;
    }

    const header = (
      <ModalHeading
        title={title}
        showCancel={showCancel}
        onCancelClick={this.props.onCloseClick}
        showBack={showBack}
        onBackClick={this.onBackClick}
        showRightButton={showRightButton}
        onRightButtonClick={onRightButtonClick}
        rightButtonLabel={rightButtonLabel}
      />
    );

    return (
      <ModalView className="templateWizardModal upgradeWizardModal" header={header} footer={footer} fixedHeight={530}>
        <PageSlider pageIndex={pageIndex} pageId={currentStep} transition={sliderTransitions.DEFAULT}>
          <ModalBody>{content}</ModalBody>
        </PageSlider>
      </ModalView>
    );
  }
}

UpgradeWizard.propTypes = {
  localStore: PropTypes.object.isRequired,
  incomingUpgradeData: PropTypes.object.isRequired,
  availableSyncProjects: PropTypes.arrayOf(PropTypes.string),
  selectedSyncProject: PropTypes.string,
  fileName: PropTypes.string,
  label: PropTypes.string,
  onUpgradeFile: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const fileName = uiStateSelectors.getFileName(state.present);
  const incomingUpgradeData = welcomeSelectors.getIncomingUpgradeData(state.present);
  const availableSyncProjects = selectors.getAllSyncProjectsFromV2Data(incomingUpgradeData);
  const selectedSyncProject = selectors.getLastSyncProjectFromV2Data(incomingUpgradeData);
  return {
    localStore: state.present,
    fileName,
    incomingUpgradeData,
    availableSyncProjects,
    selectedSyncProject
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpgradeFile: (data, suggestionGroups, groupId, templateId, fileName) => {
      dispatch(rootOperations.loadFile(data, true));
      dispatch(batchOperations.completeUpgradeWizard(suggestionGroups, fileName));
      // Needs to be dispatched separately because Undo/Redo occurs outside the batching system
      dispatch(undoRedoOperations.reset());
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.FILE_CREATED,
        groupId,
        templateId
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeWizard);
